import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=6d21078a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=6d21078a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d21078a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d21078a')) {
      api.createRecord('6d21078a', component.options)
    } else {
      api.reload('6d21078a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=6d21078a&scoped=true&", function () {
      api.rerender('6d21078a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U2N4Db8m2KFn/JS/comp/CookieBox.vue"
export default component.exports